import React, { useState, useEffect } from "react";
import { MSG } from "../constants/toastMessages";
import AdminHeader from '../layout/AdminHeader';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { apiCallingPost } from "../api/services"
import noData from "../assets/images/no-data.png"
import Loader from "../assets/images/loader.gif"
import { FiSearch, FiPlus } from "react-icons/fi";
import '../assets/css/admin-toolbar.css';
import { RiDeleteBinLine } from "react-icons/ri";
import { MdOutlineEdit } from "react-icons/md";
import { toast } from 'react-toastify';
import Pagination from "react-js-pagination";
import AddUser from './user-add';

function UserList() {
  const { userData } = useSelector((state) => state.masterData)
  const { isAuthenticated } = useSelector((state) => state.authentication);
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0)
  const [itemsCountPerPage, setItemsCountPerPage] = useState(10)
  const [userList, setUserList] = useState([])
  const [userTotalCount, setUserTotalCount] = useState("")
  const [userName, setUserName] = useState("")
  const [loading, setLoading] = useState(false)
  const [fullAccessFlag, setFullAccessFlag] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [mode, setMode] = useState("")
  const [selectedUser, setSelectedUser] = useState([])
  const [addUserFlag, SetAddUserFlag] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [selectedToDelete, setSelectedToDelete] = useState(null);
  const [saveFlag, setSaveFlag] = useState(false);
  const [isResetMfa, setIsResetMfa] = useState(false);
  const [selectedForMfaReset, setSelectedForMfaReset] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) {
      window.location.href = "/login"
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        cancelPopup();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setOffset(0);
    setActivePage(1);
    userListFn(userName, 0);
  }, [itemsCountPerPage])
  const userListFn = async (userName, offsetNo) => {
    setLoading(true)
    let postData = {
      userId: "",
      userName: userName,
      offset: offsetNo,
      max: itemsCountPerPage,
      roleId: "3"
    }
    try {
      const response = await apiCallingPost("api/user/userList", postData);

      const { data } = response;
      if (data.success === "1") {
        setUserList(data.result)
        setFullAccessFlag(data.hasFullAccess)
        setUserTotalCount(Number(data.totalCount))
      }
      else {
        setUserList([])
        setUserTotalCount(0)
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
      setUserList([]);
      setUserTotalCount(0)
    } finally {
      setLoading(false);
    }

  }

  const grantAccess = async (event, list) => {
    setFullAccessFlag(event.target.checked)
    let postData = {
      userIds: [list.user_id],
      modifiedOn: Date.now(),
      modifiedBy: userData.userId,
      hasFullAccess: event.target.checked
    }
    try {
      const response = await apiCallingPost("api/user/grantAccessToUsers", postData);
      const { data } = response;
      if (data.success === "1") {
        setFullAccessFlag(event.target.checked)
        userListFn(userName, offset);
        if (event.target.checked === true) {
          toast.success(`Full access disabled for ${list.display_name}.`);
        }
        else {
          toast.success(`Full access granted for ${list.display_name}.`);
        }
      }
      else {
        toast.error(MSG.fullAccessFailed);
      }
    } catch (error) {
      toast.error(MSG.loadUsersFailed);
    }
  }

  const handlePageChange = (pageNumber) => {
    setLoading(true);
    let offsetNo = (pageNumber - 1) * itemsCountPerPage;
    setOffset(offsetNo);
    setActivePage(pageNumber);
    userListFn(userName, offsetNo);
  }

  const addUserFn = (mode, data) => {
    setSelectedUser(data)
    setMode(mode)
    SetAddUserFlag(true)
  }

  const deleteUser = async (data) => {
    // if (window.confirm("Do you want to delete?")) {
    if (!selectedToDelete) return;
    const milliseconds = new Date().getTime();
    setSaveFlag(true)
    let postData = {
      updated_on: milliseconds,
      id: selectedToDelete.user_id
    }
    try {
      const { data } = await apiCallingPost("api/authentication/userDelete", postData);

      if (data.success === "1") {
        toast.success(MSG.userDeleted);
        setTimeout(() => {
          setSaveFlag(false)
        }, 700);
        // IdP (Firebase) auth record is now removed server-side by userDelete — no separate call needed.

        let offsetCount = 0
        if ((userTotalCount - 1) > ((activePage - 1) * itemsCountPerPage)) {
          offsetCount = offset
        }
        else {
          setActivePage(activePage - 1)
          offsetCount = offset - itemsCountPerPage
        }
        setOffset(offsetCount)
        setTimeout(() => {
          userListFn(userName, offsetCount);
        }, 1000);
      }
      else {
        toast.error(MSG.genericError);
      }

    } catch (error) {
      console.error("Error Delete User:", error);
    }
    cancelpopup();
    // }
  }
  const resetMfa = async () => {
    if (!selectedForMfaReset) return;
    setSaveFlag(true);
    try {
      const { data } = await apiCallingPost("api/mfa/reset-totp", { user_id: selectedForMfaReset.user_id });
      if (data.success === "1") {
        toast.success(MSG.mfaReset);
        userListFn(userName, offset);
      } else {
        toast.error(data.errorMessage || "Failed to reset MFA.");
      }
    } catch (error) {
      console.error("Error resetting MFA:", error);
      toast.error(MSG.resetMfaFailed);
    } finally {
      setSaveFlag(false);
      setIsResetMfa(false);
      setSelectedForMfaReset(null);
    }
  };

  const cancelPopup = () => {
    SetAddUserFlag(false)
    document.body.style.overflow = 'auto';
  }
  const cancelpopup = () => {
    setIsDelete(false)
    setSelectedToDelete(null);
  }
  return (
    <div className='main-wrapper main-wrapper-cms'>
      <AdminHeader title="User List" />
      <div className="admin-toolbar">
        <div className="container">
        <div className="admin-toolbar-search">
          <FiSearch className='search-input-icon' />
          <input type='text' className='search-input' placeholder='Name / Email / Mobile / Company Search'
            onChange={(e) => {
              setUserName(e.target.value)
              if (e.target.value === "") {
                setOffset(0)
                setActivePage(1)
                userListFn(e.target.value, 0)
              }
              else if (e.target.value.length >= 3) {
                setOffset(0)
                setActivePage(1)
                userListFn(e.target.value, 0)
              }
            }} />
        </div>
        <div className="admin-toolbar-actions">
          <button onClick={() => addUserFn("Add", "")} className="accept-all-btn"><FiPlus /> Add User</button>
        </div>
        </div>
      </div>
      <div className="container mt-4">
        {isDelete &&
          <div className="modal-admin-wrapper multiple-upload" >
            <div className="modal-ad-popup modal-md">
              <div className="modal-innerpopup ">
                <div className="modal-headdiv d-flex justify-content-between">
                  <h5 className="modal-head w-100 text-center">Do you want to delete?</h5>
                  {/* <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span> */}
                </div>
              </div>
              <div className="tag-popup-footer">
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 accept-all-gray"
                    onClick={() => cancelpopup()}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    disabled={saveFlag}
                    className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                    onClick={() => deleteUser()}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>}
        {isResetMfa &&
          <div className="modal-admin-wrapper multiple-upload">
            <div className="modal-ad-popup modal-md">
              <div className="modal-innerpopup">
                <div className="modal-headdiv d-flex justify-content-between">
                  <h5 className="modal-head w-100 text-center">Reset MFA for {selectedForMfaReset?.userDisplayName}?</h5>
                </div>
                <p className="text-center" style={{ fontSize: '13px', color: '#666' }}>
                  This will clear their authenticator setup. They will re-enroll on next login.
                </p>
              </div>
              <div className="tag-popup-footer">
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 accept-all-gray"
                    onClick={() => { setIsResetMfa(false); setSelectedForMfaReset(null); }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    disabled={saveFlag}
                    className="accept-all-btn w-100 py-2"
                    onClick={() => resetMfa()}
                  >
                    Reset MFA
                  </button>
                </div>
              </div>
            </div>
          </div>}
        <div className='table-responsive'>

          {!loading ? (
            userTotalCount > 0 ? (
              <>
                <table className="table table-bordered admin-list-table">
                  <thead>
                    <tr>
                      <th className='text-center'>#</th>
                      <th>Name</th>
                      <th className='text-center'>Company Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th className='text-center'>Date</th>
                      <th className='text-center' style={{ whiteSpace: 'nowrap' }}>Full Access</th>
                      {userData?.roleDisplayName === `Super_admin` &&
                        <th className='text-center'>Action</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {userList.map((data, i) => (
                      <tr key={data.id}>
                        <td className='text-center'>{(offset * 1) + i + 1}</td>
                        <td>{data.display_name}</td>
                        <td style={{ whiteSpace: 'nowrap' }} className='text-center'>{data.companyName}</td>
                        <td>{data.email_id}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>{data.mobile_number ? `${data.countryCode ?? ''} ${data.mobile_number}`.trim() : ''}</td>
                        <td style={{ whiteSpace: 'nowrap' }} className='text-center'>{moment(Number(data.created_on)).format('DD-MM-YYYY')}</td>
                        <td className='text-center'>
                          <div className="checkbox-wrapper-1">
                            <input id={`example${i}`} className="substituted" type="checkbox" aria-hidden="true"
                              checked={data.hasFullAccess}
                              onChange={(e) => grantAccess(e, data)}
                            />
                            <label htmlFor={`example${i}`}></label>
                          </div>
                        </td>

                        {userData?.roleDisplayName === `Super_admin` &&
                          <td className='text-center'>
                            <div className="d-inline-flex align-items-center gap-3">
                              <MdOutlineEdit className='theme-color cursor-pointer' size={20}
                                onClick={() => addUserFn("Edit", data)} />
                              <RiDeleteBinLine className='text-danger cursor-pointer' size={17}
                                onClick={() => {
                                  setSelectedToDelete(data);
                                  setIsDelete(true);
                                }}
                              />
                              {data.mfaEnabled &&
                                <span
                                  className='cursor-pointer'
                                  style={{ fontSize: '11px', color: '#e67e22', fontWeight: 600 }}
                                  title="Reset MFA"
                                  onClick={() => {
                                    setSelectedForMfaReset(data);
                                    setIsResetMfa(true);
                                  }}
                                >
                                  Reset MFA
                                </span>
                              }
                            </div>
                          </td>
                        }
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="d-flex align-items-center gap-3 flex-wrap justify-content-end  my-4 page-division">

                  <div className="ms-auto d-flex align-items-center  gap-3 flex-wrap">
                    <div className="d-flex align-items-center gap-2">
                      Rows per page:
                      <select value={itemsCountPerPage} style={{ minWidth: '60px' }} onChange={(e) => setItemsCountPerPage(e.target.value)}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                    {Number(userTotalCount) > Number(itemsCountPerPage) &&
                      <div className='pagination-wrapper m-0 p-0'>
                        <Pagination
                          activePage={activePage}
                          itemsCountPerPage={itemsCountPerPage}
                          totalItemsCount={userTotalCount}
                          pageRangeDisplayed={5}
                          onChange={(e) => handlePageChange(e)}
                        />
                      </div>
                    }
                  </div>
                </div>

              </>
            ) : (
              <div className="noData d-flex flex-column">
                <div>
                  <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
                </div>
                <div>No Data Available</div>
              </div>
            )) : (
            <div className="noData d-flex flex-column">
              <div>
                <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
              </div>
            </div>
          )}
        </div>
        {addUserFlag &&
          <AddUser cancelPopup={cancelPopup} userListFn={userListFn}
            selectedUser={selectedUser} mode={mode} setOffset={setOffset} setActivePage={setActivePage} />
        }
      </div>
    </div>
  )
}

export default UserList